import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faTools, faChartLine, faShieldAlt, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import SEO from './SEO';

const Card = ({ icon, title, points }) => (
  <div className="card group h-full flex flex-col">
    <div className="w-16 h-16 bg-gradient-to-r from-primary-green to-secondary-blue rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
      <FontAwesomeIcon icon={icon} className="text-2xl text-white" />
    </div>
    <h3 className="text-xl font-bold text-dark mb-4">{title}</h3>
    <ul className="space-y-2 flex-1">
      {points.map((p, i) => (
        <li key={i} className="flex items-center gap-2 text-sm text-dark">
          <span className="text-primary-green font-bold">✓</span>
          {p}
        </li>
      ))}
    </ul>
    <a href="/contact" className="mt-6 btn bg-primary-green text-white inline-flex items-center gap-2">
      Get quote <FontAwesomeIcon icon={faArrowRight} />
    </a>
  </div>
);

const SupportingServices = () => {
  return (
    <div className="services">
      <SEO
        title="Supporting Services | CoreNova Renewable Energy"
        description="Installation & setup, maintenance & repair, consulting & planning, and warranty & support for renewable energy projects."
        canonical="https://corenovarenewable.com/services/supporting"
        keywords="installation, maintenance, repair, consulting, planning, warranty, support"
      />

      <section className="relative bg-gradient-to-r from-primary-green to-secondary-blue text-white py-20 lg:py-32 text-center overflow-hidden">
        <div className="absolute inset-0">
          <img src="/images/service hero.png" alt="Supporting Services" className="w-full h-full object-cover opacity-60" />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-green/40 to-secondary-blue/40"></div>
        </div>
        <div className="container relative z-10">
          <h1 className="text-4xl md:text-6xl font-bold">Supporting Services</h1>
          <p className="text-xl md:text-2xl opacity-90">Everything you need to keep systems running at peak performance</p>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <Card
              icon={faCog}
              title="Installation & Setup"
              points={[
                'Certified installation team',
                'Quality assurance protocols',
                'Safety compliance',
                'Testing & commissioning',
              ]}
            />
            <Card
              icon={faTools}
              title="Maintenance & Repair"
              points={[
                'Preventive maintenance',
                '24/7 emergency support',
                'Performance monitoring',
                'Warranty services',
              ]}
            />
            <Card
              icon={faChartLine}
              title="Consulting & Planning"
              points={[
                'Energy audits',
                'System design',
                'Feasibility studies',
                'ROI analysis',
              ]}
            />
            <Card
              icon={faShieldAlt}
              title="Warranty & Support"
              points={[
                'Extended warranties',
                'Technical support',
                'Parts replacement',
                'Performance guarantees',
              ]}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default SupportingServices; 